import React from "react";
import { Col, Form, FormLabel, Row, Tab, Tabs } from "react-bootstrap";
import { labels } from "../../../../../localization/labels";
import ButtonBar from "../../../../core/ButtonBar";
import ComponentHeader from "../../../../core/ComponentHeader/ComponentHeader";
import DropDown from "../../../../core/DropDown";
import SubmitControl from "../../../../core/SubmitControl";
import InvolvementRoles from "./InvolvementRoles";

const IndividualDetail = props => {
  const entity = props.entity;
  const individual = props.individual;
  if (!entity) return null;

  return (
    <div className="container">
      <div className="tabVerticalSize" />
      <div className="containerShadow">
        <ComponentHeader
          title={labels.partyRole}
          id={entity.id}
          showBackButton
        />{" "}
        <div className="bordered_bottom_rounded">
          <Row>
            <Col sm="2">
              <FormLabel className="Label">{labels.indiviudal}</FormLabel>
            </Col>
            <Col>
              <FormLabel>{individual.name}</FormLabel>
            </Col>
          </Row>

          <Form>
            <Row>
              <Col sm="2">
                <Form.Label className="Label">{labels.name}</Form.Label>
              </Col>
              <Col>
                <Form.Group controlId="name">
                  <SubmitControl
                    autoFocus
                    type="text"
                    placeholder={labels.namePlaceholder}
                    value={entity.name}
                    onChange={props.onChange}
                    maxLength={props.maxLength.name}
                  ></SubmitControl>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel className="Label">{labels.dateFromTo}</FormLabel>{" "}
              </Col>
              <Col>
                <Form.Group controlId="dateFromTo">
                  <SubmitControl
                    type="dateRange"
                    placeholder={[
                      labels.dateFromPlaceholder,
                      labels.dateToPlaceholder
                    ]}
                    value={entity.dateFromTo}
                    onChange={props.onChange}
                    validationRule={props.validationRule.dateFromTo}
                    controlId={"dateFromTo"}
                  ></SubmitControl>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <Form.Label className="Label">{labels.roleType}</Form.Label>
              </Col>
              <Col>
                <Form.Group
                  controlId="partyRoleType"
                  className="form-group required"
                >
                  <DropDown
                    value={entity.partyRoleType}
                    options={props.partyRoleTypes.map(x => ({
                      value: x,
                      label: x.name
                    }))}
                    onChange={props.onChange}
                    targetId={"partyRoleType"}
                    placeholder={labels.roleTypePlaceholder}
                    required={props.validationRule.partyRoleType?.required}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
          {props.isNew || !entity._links ? null : (
            <div>
              <Tabs id="partyRoles_tabs" className="Tabs">
                <Tab
                  eventKey="involvementRoles"
                  title={labels.involvementRoles}
                  className="Tab"
                >
                  <InvolvementRoles
                    involvementRoleTypes={props.involvementRoleTypes}
                    parentInvolvementRoleTypes={
                      props.parentInvolvementRoleTypes
                    }
                    partyRoleId={entity.id}
                    involvementRolesUrl={entity._links.involvementRoles.href}
                    messageHandler={props.messageHandler}
                    breadcrumbsHandler={props.breadcrumbsHandler}
                    partyRoleType={entity.partyRoleType}
                  />
                </Tab>
              </Tabs>
            </div>
          )}
        </div>
        <ButtonBar onSave={props.onSave} disabled={props.disabled} />
      </div>
    </div>
  );
};

export default IndividualDetail;
